import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const PauseIcon: FC<IconProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 3C6.916 3 4 5.916 4 9.5C4 13.084 6.916 16 10.5 16C14.084 16 17 13.084 17 9.5C17 5.916 14.084 3 10.5 3ZM8.94 7.225C8.9041 7.225 8.875 7.2541 8.875 7.29V11.71C8.875 11.7459 8.9041 11.775 8.94 11.775H9.98C10.0159 11.775 10.045 11.7459 10.045 11.71V7.29C10.045 7.2541 10.0159 7.225 9.98 7.225H8.94ZM11.02 7.225C10.9841 7.225 10.955 7.2541 10.955 7.29V11.71C10.955 11.7459 10.9841 11.775 11.02 11.775H12.06C12.0959 11.775 12.125 11.7459 12.125 11.71V7.29C12.125 7.2541 12.0959 7.225 12.06 7.225H11.02Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);
